import React from 'react';
import { Result } from 'antd';
import { useAuthStore } from '@/store/authStore';
import { canManageAnyTags } from '@/store/vendorAccess';

const TagsRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { authorization } = useAuthStore();
  if (!canManageAnyTags(authorization)) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="You need the Developer role for a business unit to manage its tags."
      />
    );
  }
  return <>{children}</>;
};

export default TagsRoute;
